import { useState } from "react";
import { PackageCheck, Truck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const notify = (data, label) =>
  data.email_sent ? toast.success(`${label}: mail inviata al cliente`) : toast.warning(`${label}, ma la mail non è partita`);

export const FulfillmentActions = ({ o, onUpdated }) => {
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const [tracking, setTracking] = useState("");

  const run = async (path, body, label) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/orders/${o.id}/${path}`, body);
      notify(data, label);
      onUpdated(data.order);
      setOpen(false);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const ship = () => {
    if (tracking.trim().length < 3) return toast.error("Il codice di tracciamento è obbligatorio");
    run("shipped", { tracking_code: tracking.trim() }, "Segnato come spedito");
  };

  return (
    <>
      {!o.fulfillment && (
        <button data-testid={`mark-prepared-button-${o.id}`} className="btn-ghost-mc" disabled={busy}
          onClick={() => run("prepared", undefined, "Segnato come preparato")}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <PackageCheck className="h-4 w-4" />} Preparato
        </button>
      )}
      {o.fulfillment !== "spedito" && (
        <button data-testid={`mark-shipped-button-${o.id}`} className="btn-ghost-mc" onClick={() => setOpen(true)}>
          <Truck className="h-4 w-4" /> Spedito
        </button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={`ship-dialog-${o.id}`} className="max-w-md">
          <DialogHeader><DialogTitle className="font-display font-extrabold">Spedisci ordine {o.number}</DialogTitle></DialogHeader>
          <label className="space-y-1.5 text-xs font-bold uppercase tracking-wider text-muted-foreground">
            Codice di tracciamento (obbligatorio)
            <Input data-testid={`tracking-code-input-${o.id}`} value={tracking} onChange={(e) => setTracking(e.target.value)} className="h-11 text-foreground" autoFocus />
          </label>
          <div className="flex justify-end gap-2">
            <button className="btn-ghost-mc" onClick={() => setOpen(false)} data-testid={`ship-cancel-${o.id}`}>Annulla</button>
            <button className="btn-mc" disabled={busy || tracking.trim().length < 3} onClick={ship} data-testid={`ship-confirm-${o.id}`}>
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Segna spedito e invia mail
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
